import "../../styles/OtpMethodSelector.scss";
import { useLabelsContext } from "../../context/LabelsContext";
import { OTP_METHODS, OtpMethod } from "../../models/otp-methods";
type OtpMethodSelectorProps = {
	otpMethod: OtpMethod;
	setOtpMethod: (method: OtpMethod) => void;
	isLoading: boolean;
};

export const OtpMethodSelector: React.FC<OtpMethodSelectorProps> = ({
	otpMethod,
	setOtpMethod,
	isLoading,
}: OtpMethodSelectorProps) => {
	const { labels } = useLabelsContext();

	const handleMethodChange = (
		e?: React.MouseEvent | React.KeyboardEvent,
	): void => {
		const mouseClicked: boolean = e?.type === "click";
		const arrowClicked: boolean =
			e?.type === "keydown" &&
			"key" in e &&
			(e.key === "ArrowLeft" || e.key === "ArrowRight");

		if (mouseClicked || arrowClicked) {
			setOtpMethod(
				otpMethod === OTP_METHODS.SMS
					? OTP_METHODS.EMAIL
					: OTP_METHODS.SMS,
			);
		}
	};

	return (
		<div className='otp-method-selector'>
			<span id='otp-method-label' className='otp-label'>
				{labels?.["codeTO"]}
			</span>
			<button
				type='button'
				role='switch'
				aria-checked={otpMethod === OTP_METHODS.EMAIL}
				aria-labelledby='otp-method-label'
				className='otp-toggle'
				onClick={handleMethodChange}
				onKeyDown={e => handleMethodChange(e)}
				disabled={isLoading}
			>
				<span
					className={`otp-toggle-slider ${otpMethod === OTP_METHODS.EMAIL ? "right" : "left"}`}
					aria-hidden='true'
				/>
				<span
					className={`otp-toggle-option ${otpMethod === OTP_METHODS.SMS ? "active" : ""}`}
				>
					{labels?.["poneCrm"]}
				</span>
				<span
					className={`otp-toggle-option ${otpMethod === OTP_METHODS.EMAIL ? "active" : ""}`}
				>
					{labels?.["mailCrm"]}
				</span>
			</button>
		</div>
	);
};
